import { Charts } from './Charts';
import VehiclesChartsDataProvider from './contexts/VehiclesChartsDataContext';

const VehiclesWrapper = () => {
    return (
        <VehiclesChartsDataProvider>
            <Charts />
        </VehiclesChartsDataProvider>
    );
};

export default VehiclesWrapper;
